import { Link } from "react-router-dom";
import { FileText, Mail, ArrowRight, MessageCircle } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import SectionLabel from "@/components/site/SectionLabel";
import Seo from "@/components/site/Seo";
import { BRAND } from "@/lib/constants";

export default function News() {
  return (
    <div>
      <Seo />
      <PageHero
        pageTitle="News & Media"
        eyebrowNumber="01"
        eyebrow="News & Media"
        title="News &"
        highlight="Media"
        tagline="Press, recap content, and updates from the pilot series."
        description="The newsroom will fill in as the pilots develop. Press inquiries are welcome any time."
      />

      <section className="bg-midnight border-t border-slate-soft">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <SectionLabel number="02">Recent Updates</SectionLabel>
            <div className="card-dark p-14 corner-bracket text-center">
              <div className="label-bebas text-gold">Empty State</div>
              <h3 className="font-bebas text-white text-4xl sm:text-5xl mt-3 leading-tight">
                Updates Will Appear Here
                <br />
                <span className="gold-text">As The Pilot Series Develops.</span>
              </h3>
              <p className="font-manrope text-soft-gray mt-6 max-w-xl mx-auto">
                We will publish announcements, recap content, and press
                releases here as the program moves toward Pilot One in Fall
                2026.
              </p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <SectionLabel number="03">Media Kit</SectionLabel>
            <div className="card-dark p-8">
              <FileText className="text-gold" size={32} />
              <h3 className="font-shoulders font-bold uppercase tracking-wider text-2xl text-white mt-4">
                The Next Stage Media Kit
              </h3>
              <p className="font-manrope text-soft-gray mt-3">
                Logo lockups, photography, brand color tokens, and an event
                fact sheet. The downloadable PDF will be published as the pilot
                series approaches.
              </p>
              <button
                disabled
                data-testid="media-kit-button"
                className="btn-outline mt-6 opacity-70 cursor-not-allowed"
              >
                PDF Coming Soon
              </button>
            </div>
            <div className="card-dark p-8 mt-6">
              <Mail className="text-gold" size={28} />
              <h3 className="font-shoulders font-bold uppercase tracking-wider text-2xl text-white mt-4">
                Press Inquiries
              </h3>
              <p className="font-manrope text-soft-gray mt-3">
                Reach the producer team directly. We respond personally to
                press requests.
              </p>
              <a
                href={`mailto:${BRAND.email}?subject=Press%20Inquiry%20-%20The%20Next%20Stage`}
                data-testid="press-email-link"
                className="btn-gold mt-6"
              >
                <Mail size={18} strokeWidth={1.8} />
                Email Press Desk <ArrowRight size={16} />
              </a>
              <p className="font-manrope text-muted-ink text-xs mt-3 break-all">
                {BRAND.email}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-navy border-t border-slate-soft">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-12 text-center">
          <h2 className="font-bebas text-white text-3xl sm:text-4xl">
            Want To Cover{" "}
            <span className="gold-text">The Pilot Series?</span>
          </h2>
          <Link
            to="/contact"
            data-testid="news-contact-link"
            className="btn-outline mt-8 inline-flex"
          >
            <MessageCircle size={18} strokeWidth={1.8} />
            Contact The Team
          </Link>
        </div>
      </section>
    </div>
  );
}
